// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Ff5G","image":"Header_image__2rCqQ","name":"Header_name__2DqVL","info":"Header_info__2WdS5","infoRow":"Header_infoRow__2HCte"};